import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import EpinioServiceModel from 'models/services';
import { EPINIO_TYPES } from '../../types';
import { epinioExceptionToErrorsArray } from '../../utils/errors';
import Banner from '@components/Banner/Banner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceDeleteModal',
  setup(__props, { expose: __expose }) {

const showDeleteModal = ref<boolean>(false);
const serviceToDelete = ref<EpinioServiceModel | null>(null);
const errors = ref<Array<string>>([]);
const deletingService = ref<boolean>(false);

const store = useStore();

function openDelete(row: EpinioServiceModel) {
  serviceToDelete.value = row;
  showDeleteModal.value = true;
}

function closeDelete() {
showDeleteModal.value = false;
errors.value = [];
}

async function onSubmitDelete() {
if (!serviceToDelete.value) {
    return;
}
try {
    deletingService.value = true;
    await serviceToDelete.value.remove();
    closeDelete();
    store.dispatch('epinio/findAll', { type: EPINIO_TYPES.SERVICE_INSTANCE, opt: { force: true } });
    store.dispatch('findAll', { type: 'applications', opt: { force: true } });
} catch(e) {
    errors.value = [];
    errors.value = epinioExceptionToErrorsArray(e).map(JSON.stringify);
} finally {
    deletingService.value = false;
}
}
__expose({
  openDelete
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showDeleteModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the Instance ", -1)),
        _createElementVNode("strong", null, _toDisplayString(serviceToDelete.value?.meta.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      ((serviceToDelete.value as any)?.boundapps?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Caution: "),
              _createTextVNode("The following applications are bound to the Service Instance about to be deleted. Proceeding will unbind them prior to deletion.")
            ], -1)),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((serviceToDelete.value as any)?.boundapps || [], (app) => {
                return (_openBlock(), _createElementBlock("li", { key: app }, _toDisplayString(app), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "No applications are bound to this Service Instance.")),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (err, i) => {
        return (_openBlock(), _createBlock(Banner, {
          key: i,
          color: "error",
          label: err
        }, null, 8, ["label"]))
      }), 128))
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "Cancel", 32),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        disabled: deletingService.value,
        variant: "destructive",
        onButtonClick: onSubmitDelete
      }, _toDisplayString(deletingService.value ? 'Deleting...' : _ctx.t('generic.delete')), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})